import {useDispatch, useSelector} from "react-redux";
import {cloneDeep} from "lodash";
import InputComponent from "../../../components/input.component";
import React from "react";
import {setMainPageShopByCategoryDetail} from "../../../reducers/main-page.reducer";

const ItemCategory = ({fieldList, index}) => {
    const dispatch = useDispatch()
    const {shopByCategoryDetail, mainPageErrorMessage} = useSelector(state => state.mainPageReducer)

    const onChangeInput = (key, value) => {
        const copyItemList = cloneDeep(shopByCategoryDetail.item_list)
        copyItemList[index][key] = value
        dispatch(setMainPageShopByCategoryDetail({item_list: copyItemList}))
    }

    return (
        <div className={"row space-x-16"}>
            <div className={"col space-y-4 w-1/2"}>
                <InputComponent item={fieldList[0][0]} data={shopByCategoryDetail?.item_list?.[index]?.[fieldList[0][0].key]} error={mainPageErrorMessage[`item_list[${index}]`] ?? {}} onChange={onChangeInput}/>
            </div>
            <div className={"col space-y-4 w-1/2"}>
                {fieldList[1].map((item, i) => (
                    <InputComponent key={i} item={item} data={shopByCategoryDetail?.item_list?.[index]?.[item.key]} error={mainPageErrorMessage[`item_list[${index}]`] ?? {}} onChangeInput={onChangeInput}/>
                ))}
            </div>
        </div>
    )
}

export default ItemCategory